export default{sources:{avif:"__VITE_ASSET__zkp8kjGW__ 400w",webp:"__VITE_ASSET__DuWG0JP2__ 400w"},img:{src:"__VITE_ASSET__Bmofz7Wx__",w:400,h:267}};